export class ProfessionalData{

  profession: string;
  professionName: string;
  originIncome: string;
  originIncomePrevious: string;
  originIncomeName: string;
  originIncomeNamePrevious: string;
  entityThatWorks: string;
  entityCnpj: string;
  entityThatWorksPrevious: string;
  entityCnpjPrevious: string;
  isCompleted?: boolean;
  incomeRequired: boolean;
  incomeRequiredPrevious: boolean;
  patrimonyRequired: boolean;
  patrimonyRequiredPrevious: boolean;
  editData?: [];
  firstEdit? = [];
}
